export default "__VITE_ASSET__caeae37e__"